export default "__VITE_ASSET__CKC7Fw4___"